export default "__VITE_ASSET__2$LtLFQdS6IeO$uJxLxRJQ__ 480w, __VITE_ASSET__cLZLOsSELI_GmwKcVOKKRw__ 768w, __VITE_ASSET___ewJD0zO9$SsiDvawfmAUw__ 1200w";